import { PropsWithChildren } from "react";

export const Identity = <T extends {}>({ children }: PropsWithChildren<T>) => (
  <>{children ?? null}</>
);
